import { FaroCoreApiUtils } from "@stellar/core-api-client";

/** Entity type to change access level */

/** Get the description for a given access level and entity type */
export function getAccessLevelDescription(type, accessLevel) {
  switch (accessLevel) {
    case "private":
      return `The ${type} can only be seen by members who are signed in and invited.`;
    case "unlisted":
      return `The ${type} can be seen by everyone with the link.`;
    default:
      return "";
  }
}

/** Interface for an access level item */

/** Access level items array */
export function getAccessLevelItems(type) {
  switch (type) {
    case "project":
      return [{
        label: FaroCoreApiUtils.Project.AccessLevelDisplayNames.private,
        description: getAccessLevelDescription("project", "private"),
        value: "private"
      }, {
        label: FaroCoreApiUtils.Project.AccessLevelDisplayNames.unlisted,
        description: getAccessLevelDescription("project", "unlisted"),
        value: "unlisted"
      }];
    case "snapshot":
      return [{
        label: FaroCoreApiUtils.Project.AccessLevelDisplayNames.private,
        description: getAccessLevelDescription("snapshot", "private"),
        value: "private"
      }, {
        label: FaroCoreApiUtils.Project.AccessLevelDisplayNames.unlisted,
        description: getAccessLevelDescription("snapshot", "unlisted"),
        value: "unlisted"
      }];
    default:
      return [];
  }
}

/** Type guard to check if a given string is a valid project access level */
export function isProjectAccessLevel(accessLevel) {
  return accessLevel === "private" || accessLevel === "unlisted";
}